// FIX-895 — /static is served with a one-year max-age (vercel.json): without a
// new URL, a browser that already opened a previous CGV.pdf would keep showing
// it. Bump `v` with every new static/CGV.pdf (and CGV_URL in rj-mobile).
const CGV_URL = '/static/CGV.pdf?v=2026-10-12';

export default CGV_URL;
